import styled from 'styled-components';

interface ImageContainerProps {
  $imageUrl: string;
}

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 900px;
`;

export const Title2 = styled.h2`
  font-size: 28px;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 20px;
  color: ${({ theme }) => theme?.colors?.text?.headings};
`;

export const InfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 32px;
  padding: 32px 0px;
  color: ${({ theme }) => theme?.colors?.text?.paragraphs};
  border-radius: 8px;

  @media (max-width: 760px) {
    flex-direction: column;
    gap: 16px;
  }

  @media (max-width: 480px) {
    padding: 16px 0px;
    gap: 8px;
  }
`;

export const MessageText = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme?.colors?.text?.paragraphs};
  margin: 0;
  padding: 0;
  line-height: 21.17px;
  font-weight: 400;
  width: 434px;

  @media (max-width: 960px) {
    width: 100%;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    width: 100%;
  }
`;

export const MissionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  width: 100%;
  max-width: 100%;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const ImageContainer = styled.div<ImageContainerProps>`
  width: 900px;
  height: 506px;
  background-image: url(${props => props.$imageUrl});
  background-size: cover;
  background-position: center;
  margin-bottom: 32px;
  border-radius: 12px;
  box-shadow: 0 0 60px rgba(139, 0, 139, 0.2);
  transition: box-shadow 0.3s ease, filter 0.3s ease;

  @media (max-width: 960px) {
    width: 100%;
    padding-top: 56.25%;
    height: 0;
    margin-bottom: 16px;
    background-size: cover;
    background-position: center;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  color: ${({ theme }) => theme?.colors?.text?.headings};
  margin: 0;
  padding: 0;
  align-self: flex-start;

  @media (max-width: 960px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 434px;

  @media (max-width: 760px) {
    width: 100%;
    gap: 16px;
  }

  @media (max-width: 480px) {
    gap: 8px;
  }
`;

export const MissionsContainer = styled.div`
  margin-top: 64px;
  margin-bottom: 64px;
  width: 100%;

  @media (max-width: 960px) {
    margin-top: 40px;
    margin-bottom: 40px;
  }

  @media (max-width: 480px) {
    margin-top: 20px;
    margin-bottom: 20px;
  }
`;

export const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;